import { useTranslation } from "react-i18next"
import { useNavigate, useParams } from "react-router-dom"

import { BreadcrumbNav } from "@/components/breadcrumb-nav"
import { LoadingState } from "@/components/loading-state"
import { PageHeader } from "@/components/page-header"
import { ContractForm } from "@/features/contracts/components/contract-form"
import { useUpdateContract } from "@/features/contracts/hooks/use-contract-mutations"
import { useContract } from "@/features/contracts/hooks/use-contracts"
import { paths } from "@/routes/paths"

export function ContractEditPage() {
  const { contractId = "" } = useParams<{ contractId: string }>()
  const { t } = useTranslation("contracts")
  const navigate = useNavigate()
  const { data: contract, isLoading } = useContract(contractId)
  const update = useUpdateContract(contractId)

  if (isLoading || !contract) {
    return <LoadingState />
  }

  return (
    <div className="flex flex-col gap-6">
      <BreadcrumbNav
        crumbs={[
          { label: t("title"), to: paths.contracts },
          {
            label: contract.contractNumber ?? `#${contract.id}`,
            to: paths.contractDetail(contract.id),
          },
          { label: t("editContract") },
        ]}
      />
      <PageHeader title={t("editContract")} />
      <ContractForm
        contract={contract}
        isSubmitting={update.isPending}
        onSubmit={(payload) => {
          update.mutate(payload, {
            onSuccess: () => {
              navigate(paths.contractDetail(contractId))
            },
          })
        }}
      />
    </div>
  )
}
